import React, { useState } from 'react';
import { Anchor, Check, Send, ArrowRight } from 'lucide-react';
import Logo from '../../components/Logo';
import Footer from '../../components/Footer';
import ThemeToggle from '../../components/ThemeToggle';
import WalletMenu from '../../components/WalletMenu';
import NavigationMenu from '../../components/NavigationMenu';

// Yacht data
const yachts = [
  {
    id: 1,
    name: 'Oceanic Majesty',
    type: 'Motor Yacht',
    length: '45m',
    capacity: '12 guests',
    crew: '9 crew',
    price: '€150,000/week',
    location: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80'
  },
  {
    id: 2,
    name: 'Azure Voyager',
    type: 'Sailing Yacht',
    length: '38m',
    capacity: '8 guests',
    crew: '6 crew',
    price: '€95,000/week',
    location: 'Caribbean',
    image: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80'
  },
  {
    id: 3,
    name: 'Sovereign Seas',
    type: 'Super Yacht',
    length: '65m',
    capacity: '16 guests',
    crew: '18 crew',
    price: '€350,000/week',
    location: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1577431380157-3f1ca8f76a68?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80'
  },
  {
    id: 4,
    name: 'Celestial Wave',
    type: 'Motor Yacht',
    length: '50m',
    capacity: '12 guests',
    crew: '10 crew',
    price: '€180,000/week',
    location: 'South Pacific',
    image: 'https://images.unsplash.com/photo-1599772310251-5cbe9b8d0ef4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80'
  },
  {
    id: 5,
    name: 'Nautical Dream',
    type: 'Sailing Yacht',
    length: '32m',
    capacity: '6 guests',
    crew: '4 crew',
    price: '€75,000/week',
    location: 'Greek Islands',
    image: 'https://images.unsplash.com/photo-1605281317010-fe5ffe798166?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2344&q=80'
  },
  {
    id: 6,
    name: 'Royal Odyssey',
    type: 'Super Yacht',
    length: '72m',
    capacity: '18 guests',
    crew: '22 crew',
    price: '€420,000/week',
    location: 'Caribbean',
    image: 'https://images.unsplash.com/photo-1586694681327-5082e2e5f7f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80'
  },
  {
    id: 7,
    name: 'Coastal Serenity',
    type: 'Motor Yacht',
    length: '35m',
    capacity: '8 guests',
    crew: '6 crew',
    price: '€85,000/week',
    location: 'Adriatic Sea',
    image: 'https://images.unsplash.com/photo-1565778655447-125a8c77e9e9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80'
  },
  {
    id: 8,
    name: 'Majestic Horizon',
    type: 'Expedition Yacht',
    length: '55m',
    capacity: '14 guests',
    crew: '16 crew',
    price: '€250,000/week',
    location: 'Southeast Asia',
    image: 'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80'
  }
];

export default function YachtCharter() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    departure: '',
    destination: '',
    date: '',
    passengers: '',
    message: '',
    yachtId: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedYacht, setSelectedYacht] = useState<number | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleYachtSelect = (id: number) => {
    setSelectedYacht(id);
    setFormData(prev => ({
      ...prev,
      yachtId: id.toString()
    }));
    
    // Scroll to request form
    document.getElementById('request-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // In a real application, you would send this data to your backend
    console.log('Sending yacht charter request to bookings@privatecharterx.com', formData);
    
    setIsSubmitting(false);
    setIsSubmitted(true);
    setFormData({
      name: '',
      email: '',
      phone: '',
      departure: '',
      destination: '',
      date: '',
      passengers: '',
      message: '',
      yachtId: ''
    });
    
    // Reset success message after 5 seconds
    setTimeout(() => {
      setIsSubmitted(false);
    }, 5000);
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-b from-gray-50 to-white border-b border-gray-100">
        <div className="max-w-8xl mx-auto">
          <div className="flex items-center justify-between py-4 px-6">
            <div className="flex items-center gap-8">
              <Logo />
              <NavigationMenu />
            </div>
            <div className="flex items-center gap-4">
              <WalletMenu onShowDashboard={() => {}} />
              <ThemeToggle />
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1 pt-[88px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Yacht Charter</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Experience the ultimate in luxury at sea with our premium yacht charter services. Explore the world's most beautiful destinations in unparalleled style and comfort.
            </p>
          </div>

          {/* Features Section */}
          <div id="features" className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 scroll-mt-32">
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Safety First</h3>
              <p className="text-base text-gray-600">
                All yachts in our fleet meet the highest maritime safety standards with experienced crews and rigorous maintenance.
              </p>
              <ul className="mt-4 space-y-2">
                <li className="flex items-start gap-2">
                  <Check size={18} className="text-green-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600">Certified crew members</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check size={18} className="text-green-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600">Regular safety inspections</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center mb-4">
                <Anchor size={24} className="text-white" />
              </div>
              <h3 className="text-xl font-bold mb-2">Expert Crew</h3>
              <p className="text-base text-gray-600">
                Professional crew members with extensive experience ensure a smooth and enjoyable journey at sea.
              </p>
              <ul className="mt-4 space-y-2">
                <li className="flex items-start gap-2">
                  <Check size={18} className="text-green-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600">Experienced captains</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check size={18} className="text-green-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600">Professional service staff</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path>
                  <line x1="16" y1="8" x2="2" y2="22"></line>
                  <line x1="17.5" y1="15" x2="9" y2="15"></line>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Personalized Service</h3>
              <p className="text-base text-gray-600">
                Enjoy bespoke catering, luxury amenities, and a dedicated concierge to handle every aspect of your journey.
              </p>
              <ul className="mt-4 space-y-2">
                <li className="flex items-start gap-2">
                  <Check size={18} className="text-green-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600">Custom itineraries</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check size={18} className="text-green-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600">Gourmet dining options</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Yacht Collection */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-center">Our Yacht Collection</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {yachts.map((yacht) => (
                <div 
                  key={yacht.id} 
                  className="bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => handleYachtSelect(yacht.id)}
                >
                  <div className="h-48 overflow-hidden">
                    <img 
                      src={yacht.image} 
                      alt={yacht.name} 
                      className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-lg font-bold mb-1">{yacht.name}</h3>
                    <p className="text-sm text-gray-500 mb-2">{yacht.type}</p>
                    <div className="space-y-1 text-sm">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600">Length</span>
                        <span className="font-medium">{yacht.length}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600">Capacity</span>
                        <span className="font-medium">{yacht.capacity}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600">Price</span>
                        <span className="font-medium">{yacht.price}</span>
                      </div>
                    </div>
                    <button 
                      className="w-full mt-4 bg-black text-white py-2 rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors"
                    >
                      Request Quote
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Request Form */}
          <div id="request-form" className="mb-16 scroll-mt-32">
            <div className="bg-gray-50 rounded-3xl overflow-hidden">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="p-8 lg:p-12">
                  <h2 className="text-3xl font-bold mb-4">Request a Quote</h2>
                  <p className="text-base text-gray-600 mb-8">
                    Fill out the form below and our team will provide you with a customized quote for your yacht charter needs.
                  </p>
                  
                  {isSubmitted ? (
                    <div className="bg-green-50 text-green-700 p-6 rounded-xl flex items-start gap-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0 mt-0.5">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      <div>
                        <h3 className="font-bold text-lg mb-1">Request Sent Successfully!</h3>
                        <p>Thank you for your inquiry. Our team will contact you shortly at the email address provided.</p>
                      </div>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                            Full Name
                          </label>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          />
                        </div>
                        
                        <div>
                          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                            Email Address
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          />
                        </div>
                      </div>
                      
                      <div>
                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        />
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label htmlFor="departure" className="block text-sm font-medium text-gray-700 mb-1">
                            Departure Port
                          </label>
                          <input
                            type="text"
                            id="departure"
                            name="departure"
                            value={formData.departure}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          />
                        </div>
                        <div>
                          <label htmlFor="destination" className="block text-sm font-medium text-gray-700 mb-1">
                            Destination
                          </label>
                          <input
                            type="text"
                            id="destination"
                            name="destination"
                            value={formData.destination}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          />
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">
                            Charter Start Date
                          </label>
                          <input
                            type="date"
                            id="date"
                            name="date"
                            value={formData.date}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          />
                        </div>
                        <div>
                          <label htmlFor="passengers" className="block text-sm font-medium text-gray-700 mb-1">
                            Number of Guests
                          </label>
                          <select
                            id="passengers"
                            name="passengers"
                            value={formData.passengers}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                          >
                            <option value="">Select</option>
                            {[2, 4, 6, 8, 10, 12, 14, 16, 18].map(num => (
                              <option key={num} value={num}>{num}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      
                      <div>
                        <label htmlFor="yachtId" className="block text-sm font-medium text-gray-700 mb-1">
                          Preferred Yacht (Optional)
                        </label>
                        <select
                          id="yachtId"
                          name="yachtId"
                          value={formData.yachtId}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent"
                        >
                          <option value="">No preference</option>
                          {yachts.map(yacht => (
                            <option key={yacht.id} value={yacht.id}>{yacht.name} ({yacht.type})</option>
                          ))}
                        </select>
                      </div>
                      
                      <div>
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                          Additional Information
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          rows={4}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent resize-none"
                          placeholder="Special requests, preferences, etc."
                        ></textarea>
                      </div>
                      
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-colors font-medium disabled:opacity-70 flex items-center justify-center gap-2"
                      >
                        {isSubmitting ? (
                          <>
                            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                            <span>Sending...</span>
                          </>
                        ) : (
                          <>
                            <Send size={18} />
                            <span>Send Request</span>
                          </>
                        )}
                      </button>
                    </form>
                  )}
                </div>
                
                <div className="hidden lg:block relative">
                  <img 
                    src="https://images.unsplash.com/photo-1588019541002-f79d8f50a4f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2574&q=80" 
                    alt="Luxury Yacht Interior" 
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div id="faq" className="mb-16 scroll-mt-32">
            <h2 className="text-3xl font-bold mb-8 text-center">Frequently Asked Questions</h2>
            <div className="space-y-4 max-w-4xl mx-auto">
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <details className="group">
                  <summary className="flex items-center justify-between p-4 cursor-pointer">
                    <h3 className="font-medium">How much does it cost to charter a yacht?</h3>
                    <span className="transition-transform group-open:rotate-180">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </span>
                  </summary>
                  <div className="p-4 pt-0 text-base text-gray-600">
                    Yacht charter costs vary based on the size of the vessel, season, and destination. Motor yachts typically range from €50,000 to €200,000 per week, while sailing yachts range from €30,000 to €150,000 per week. Contact us for a precise quote tailored to your requirements.
                  </div>
                </details>
              </div>
              
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <details className="group">
                  <summary className="flex items-center justify-between p-4 cursor-pointer">
                    <h3 className="font-medium">What's included in a yacht charter?</h3>
                    <span className="transition-transform group-open:rotate-180">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </span>
                  </summary>
                  <div className="p-4 pt-0 text-base text-gray-600">
                    Our yacht charters typically include the vessel, professional crew, insurance, and standard amenities. Additional costs may include fuel, dockage, food and beverages, and special requests. We offer both all-inclusive packages and customizable options to suit your preferences.
                  </div>
                </details>
              </div>
              
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <details className="group">
                  <summary className="flex items-center justify-between p-4 cursor-pointer">
                    <h3 className="font-medium">How far in advance should I book a yacht charter?</h3>
                    <span className="transition-transform group-open:rotate-180">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </span>
                  </summary>
                  <div className="p-4 pt-0 text-base text-gray-600">
                    For peak season charters (summer in the Mediterranean, winter in the Caribbean), we recommend booking 6-12 months in advance to secure your preferred yacht and dates. For off-peak seasons, 3-6 months is typically sufficient. However, we can sometimes accommodate last-minute bookings depending on availability.
                  </div>
                </details>
              </div>
              
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <details className="group">
                  <summary className="flex items-center justify-between p-4 cursor-pointer">
                    <h3 className="font-medium">What qualifications do your yacht crews have?</h3>
                    <span className="transition-transform group-open:rotate-180">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </span>
                  </summary>
                  <div className="p-4 pt-0 text-base text-gray-600">
                    All our yacht captains hold internationally recognized certifications and have extensive experience in their cruising areas. Our crew members are professionals with specialized training in their respective roles, from engineers to chefs to stewards. Many have worked on luxury yachts for years and are committed to providing exceptional service.
                  </div>
                </details>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-black text-white p-12 rounded-2xl text-center">
            <h2 className="text-3xl font-bold mb-4">Ready to Set Sail?</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              Book your luxury yacht charter today and experience the ultimate in maritime luxury.
            </p>
            <a 
              href="#request-form" 
              className="inline-flex items-center gap-2 bg-white text-black px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              Request a Quote <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}